import React, { useState } from "react";

export const ShowMoreCell = ({ rowData, column }: any) => {
    const [expanded, setExpanded] = useState(false);
    const text = rowData[column.key];

    if (!text) return null;

    const limit = 400;
    const isLong = text.length > limit;
    const displayText = expanded ? text : text.substring(0, limit);

    return (
        <div>
            <div>{displayText}{(isLong && !expanded) && "....."}
                {isLong && (

                    <span
                        style={{
                            color: "#116ed1ff",
                            cursor: "pointer",
                            fontSize: "12px",
                            marginTop: "5px",
                            fontWeight: "600",
                            display: "inline-block",
                        }}
                        onClick={() => setExpanded(!expanded)}
                    >
                        {expanded ? "Show Less" : "Show More"}
                    </span>
                )}</div>


        </div>
    );
};
